(function () {
  const CM_PER_IN = 2.54;
  const RANGE_SEPARATOR = '–';

  function formatMeasurement(num) {
    const rounded = Math.round(num * 10) / 10;
    if (Math.abs(rounded - Math.round(rounded)) < 0.05) {
      return String(Math.round(rounded));
    }
    return String(rounded);
  }

  function parseMeasurementValue(raw) {
    const normalized = raw.trim().replace(/[–—]/g, '-');
    const parts = normalized.split('-').map((part) => part.trim()).filter(Boolean);

    if (parts.length >= 2) {
      const min = parseFloat(parts[0], 10);
      const max = parseFloat(parts[1], 10);
      if (!Number.isNaN(min) && !Number.isNaN(max)) {
        return { type: 'range', min, max };
      }
    }

    const single = parseFloat(parts[0], 10);
    if (!Number.isNaN(single)) {
      return { type: 'single', value: single };
    }

    return { type: 'text', value: raw };
  }

  function formatMeasurementDisplay(parsed, unit) {
    if (parsed.type === 'text') {
      return parsed.value;
    }

    const convert = (cm) => (unit === 'in' ? cm / CM_PER_IN : cm);

    if (parsed.type === 'range') {
      return `${formatMeasurement(convert(parsed.min))}${RANGE_SEPARATOR}${formatMeasurement(convert(parsed.max))}`;
    }

    return formatMeasurement(convert(parsed.value));
  }

  function updateTableUnit(toggle, unit) {
    toggle.dataset.unit = unit;

    const switchBtn = toggle.querySelector('.product-measurements-unit-toggle__switch');
    if (switchBtn) {
      switchBtn.setAttribute('aria-pressed', unit === 'in' ? 'true' : 'false');
    }

    const table = toggle.closest('table');
    if (!table) return;

    table.querySelectorAll('[data-measurement-value]').forEach((cell) => {
      const raw = cell.dataset.measurementValue;
      if (!raw) return;

      const parsed = parseMeasurementValue(raw);
      cell.textContent = formatMeasurementDisplay(parsed, unit);
    });
  }

  document.addEventListener('click', (event) => {
    const switchBtn = event.target.closest('.product-measurements-unit-toggle__switch');
    if (!switchBtn) return;

    const toggle = switchBtn.closest('.product-measurements-unit-toggle');
    if (!toggle) return;

    const nextUnit = toggle.dataset.unit === 'cm' ? 'in' : 'cm';
    updateTableUnit(toggle, nextUnit);
  });
})();
